// @ts-strict-ignore
import * as React from 'react';
import { AppleAppStoreState, AppleAppStoreDefaultSettings, AppleAppStoreData } from '../types';
import { antGrey, releaseSettingsDescriptionsStyle } from './styles/globalStyles';
import { useSelector } from 'react-redux';
import { RootState } from '../reducers/reducers';
import {
    selectAppStoreDefaults,
    selectAppStoreType,
    selectAutoReleaseStepAutomationRun,
    selectRelease,
    selectReleaseIsRunwayAutomated,
} from '../selectors/selectors';
import { ReleaseComponentProps, Nullable, StepRunComponentProps } from '../typescriptHelpers';
import AppleAppStoreReleaseSettingsDescriptions from './appSettings/AppleAppStoreReleaseSettingsDescriptions';
import { getIsReleaseAutomationInactiveBecauseOfASCSetting } from '@/helpers';

interface AppleAppStoreReleaseSettingsProps extends ReleaseComponentProps {
    appStoreState?: AppleAppStoreState;
    appStoreReleaseSettings?: AppleAppStoreDefaultSettings;
    appStoreData?: AppleAppStoreData;
    isRollback: boolean;
    onShowAppStoreReleaseSettings?: () => void;
    stepRunComponentProps: Nullable<StepRunComponentProps>;
}

const AppleAppStoreReleaseSettings: React.FC<AppleAppStoreReleaseSettingsProps> = (
    props: AppleAppStoreReleaseSettingsProps,
) => {
    const { isRollback, appStoreReleaseSettings, appStoreData, stepRunComponentProps } = props;

    const appStoreDefaults = useSelector((state: RootState) => selectAppStoreDefaults(state, props.appId));

    const isRunwayReleaseAutomationInactiveBecauseOfApple = useSelector((state: RootState) => {
        const appStoreType = selectAppStoreType(state, props.appId);
        const releaseAutomation = selectAutoReleaseStepAutomationRun(state, props.releaseId);
        const release = selectRelease(state, props.releaseId);

        return getIsReleaseAutomationInactiveBecauseOfASCSetting(
            releaseAutomation,
            appStoreData,
            appStoreType,
            release.type,
        );
    });

    const willBeReleasedByRunway = useSelector((state: RootState) =>
        selectReleaseIsRunwayAutomated(state, props.appId, props.releaseId),
    );

    return (
        <div style={{ display: 'flex', flexDirection: 'column', padding: '0 12px' }}>
            <AppleAppStoreReleaseSettingsDescriptions
                orgId={props.orgId}
                appId={props.appId}
                willBeReleasedByRunway={willBeReleasedByRunway}
                isRunwayReleaseAutomationInactiveBecauseOfApple={isRunwayReleaseAutomationInactiveBecauseOfApple}
                appDefaultSettings={appStoreDefaults as AppleAppStoreDefaultSettings}
                appStoreReleaseSettings={appStoreReleaseSettings}
                appStoreData={appStoreData}
                isRollback={isRollback}
                labelStyle={{ ...releaseSettingsDescriptionsStyle, marginTop: 12 }}
                contentStyle={{ color: antGrey.grey7, marginTop: 12 }}
                colon={false}
                stepRunComponentProps={stepRunComponentProps}
            />
        </div>
    );
};

export default AppleAppStoreReleaseSettings;
